module.exports = require("@swa-ui/core/src/Section/Section.module.scss");